"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.scrollPercent = exports.scrollService = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var isScrolling;

var scrollService = function scrollService(e, callback) {
  var bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;

  if (bottom && callback) {
    callback();
  }
};

exports.scrollService = scrollService;

var scrollPercent = function scrollPercent(e, callback) {
  clearTimeout(isScrolling);

  var newEvent = _objectSpread({}, e); // Set a timeout to run after scrolling ends


  isScrolling = setTimeout(function (e) {
    var remaining = e.target.scrollHeight - e.target.clientHeight;
    var finalPercent = e.target.scrollTop / remaining * 100; // Run the callback

    if (callback) {
      callback(finalPercent);
    }
  }, 66, newEvent);
};

exports.scrollPercent = scrollPercent;
var _default = scrollService;
exports["default"] = _default;